<template>
	<div class="block seo yellow disabled">
		<router-link :to="{path: `/client/${getClientSlug}/seo`}">
			<h3>SEO</h3>
			<div class="row">
				<p>Google Ranking change</p>
				<div class="stats">
					<p class="number">{{ rankingVal }}</p>
					<div class="conversion-rate down">
						<div class="grid-container">
							<div class="col">
								<p>{{ conversionRate }}</p>
							</div>
							<div class="col">
								<span class="arrow">
									<i class="fa-solid fa-arrow-up-long"></i>
								</span>
							</div>
						</div>
					</div>
					<!-- end conversion-rate -->
				</div>
				<!-- end stats -->
				<p class="dark">than last month</p>
			</div>
			<!-- end row -->
			<div class="row graph-row">
				<div class="graph">
					<span></span>
					<img class="graph" v-bind:src="graph" />
				</div>
				<!-- end graph -->
			</div>
			<!-- end row -->
			<span class="arrow-link">SEO information</span>
		</router-link>
	</div>
</template>

<script>
import {mapGetters} from "vuex"

let ranking = "-180"
let conversionPercent = "56.65%"

export default {
	data() {
		return {
			graph: require("../../assets/img/yellow-graph.png"),
			rankingVal: ranking === "" ? "--" : ranking,
			conversionRate: conversionPercent === "" ? "--" : conversionPercent,
		}
	},
	computed: {
		...mapGetters("client", ["getClientSlug"]),
	},
}
</script>
